import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../../../services/common.service";
import { SiteService } from "../../../../services/site.service";

@Component({
	selector: 'page-faqs-index',
	templateUrl: './index.component.html',
})
export class PageInfoFaqsIndexComponent implements OnInit {

    public $: any;

    public faqData: any;

	constructor(
        public commonService: CommonService,
        public siteService: SiteService,
    ) {
        this.$ = this.commonService.getJQuery();
	}

	async ngOnInit() {

        /* SET PAGE TITLE */
        this.commonService.setTitle(`夜行バス・高速バスのご予約に関するよくあるご質問 | バス格安予約のバスブックマーク`);

        this.commonService.showPageLoader("しばらくお待ちください。");

        /* GET FAQS DATA */
        this.faqData = await this.siteService.getFaqData();

		/* EXECUTE INLINE JAVASCRIPT */
        this.inlineJS();

        this.commonService.hidePageLoader();
    }

    inlineJS() {
        let self = this;

        self.$(document).ready(function() {

            self.$('.faq-body-box').click(function() {
                self.$(this).toggleClass("is--active");
                self.$(this).children(".faq-body-box__a").slideToggle();
            });
            self.$('.acc-title').click(function() {
                self.$(this).toggleClass("is--active");
                self.$(this).next(".faq-body").slideToggle();
            });

        });
    }

}
